import React from 'react';
import NumberFormat from 'react-number-format';
import { v4 as uuidv4 } from 'uuid';

const PhoneInput = props => {
  const { onChange, inputRef, ...rest } = props;

  return (
    <NumberFormat
      {...rest}
      id={uuidv4()}
      getInputRef={inputRef}
      format="+1 (###) ###-####"
      onValueChange={values => {
        onChange({
          target: {
            name: props.name,
            value: values.value.length > 1 && values.value.charAt(0) === '1' ? values.value.slice(1) : values.value,
          },
        });
      }}
    />
  );
};

export default PhoneInput;



// WEBPACK FOOTER //
// ./src/sharedComponents/BuyerRegistrationForm/components/PhoneInput/PhoneInput.js